<template>
  <div class="c-base-select-outlined">
    <label
      v-if="label"
      :for="id"
      :class="statusClasses"
      class="c-label"
      v-html="label"
    ></label>
    <select
      v-model="modelValue"
      :id="id"
      :class="statusClasses"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :rows="rows"
      class="c-select"
    >
      <option
        v-for="(option, index) in options"
        :key="`${index}-${Math.random()}`"
        :value="option.value"
        :disabled="option.disabled"
        :selected="option.selected"
      >
        {{ option.text }}
      </option>
    </select>

    <p v-if="error" class="c-error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: `select-${Math.random()}`,
    },
    value: {
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasSuccess: {
      type: Boolean,
    },
    hasError: {
      type: Boolean,
    },
    error: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 5,
    },
  },

  computed: {
    statusClasses() {
      return {
        'is-error': this.hasError,
        'is-success': this.hasSuccess,
      }
    },
  },

  data() {
    return {
      modelValue: this.value,
    }
  },

  watch: {
    modelValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.modelValue = newValue
    },
  },
}
</script>

<style lang="scss">
.c-base-select-outlined {
  .c-label {
    display: block;
    align-items: center;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: normal;
    color: $neutral;
    line-height: 20px;
    > strong {
      font-weight: bold;
      color: inherit;
    }
    &.is-error {
      color: $error;
    }
    &.is-success {
      color: $tertiary;
    }
  }

  .c-select {
    display: flex;
    align-items: center;
    min-width: 100%;
    height: 48px;
    padding: 0 16px;
    font-size: 16px;
    color: $neutral;
    border-radius: 8px;
    background-color: $white;
    border: 1px solid rgba($neutrallight, 0.5);
    &::placeholder {
      color: rgba($neutral, 0.5);
    }
    &:hover {
      border-color: $neutrallight;
    }
    &:focus,
    &:active {
      border-color: $neutrallight;
      box-shadow: 0px 0px 3px 0px $neutrallight;
      outline: none;
    }
    &.is-success {
      border-color: $tertiary;
      box-shadow: none;
    }
    &.is-error {
      border-color: $error;
      box-shadow: none;
    }
    &:disabled {
      color: #cbcbcb;
      cursor: not-allowed;
      pointer-events: none;
      border-color: #f3f3f3;
      background-color: #f3f3f3;
      opacity: 1;
    }
  }

  .c-error {
    margin-top: 2px;
    font-size: 12px;
    color: $error;
    line-height: 15.6px;
  }
}
</style>
